import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=09f5a1b1&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=09f5a1b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5a1b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f5a1b1')) {
      api.createRecord('09f5a1b1', component.options)
    } else {
      api.reload('09f5a1b1', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=09f5a1b1&scoped=true", function () {
      api.rerender('09f5a1b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/formBox.vue"
export default component.exports